import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {TreeNode} from 'primeng/api';
import {CommonTransformationService} from "../services/common-transformation.service";
import {ProjectService} from "../services/project.service";
import {LocalCacheService} from "@app/core/local-cache/local-cache.service";
import {ContractSummary} from "@app/shared";
import {plainToClass} from "class-transformer";

@Component({
  selector: 'app-contract-tree',
  templateUrl: './contract-tree.component.html',
  styleUrls: ['./contract-tree.component.css']
})
export class ContractTreeComponent implements OnInit, OnChanges {

  @Input()
  selectedContractId: number;

  @Output()
  handler: EventEmitter<TreeNode<ContractSummary>> = new EventEmitter<TreeNode<ContractSummary>>();

  contractTree: TreeNode<ContractSummary>[];
  selectedContract: TreeNode;

  constructor(private projectService: ProjectService, private transformService: CommonTransformationService, private cache: LocalCacheService) {
  }

  ngOnInit() {
    if (this.cache?.contractSummary?.length > 0) {
      this.contractTree = <TreeNode<ContractSummary>[]>this.transformService.convertToTree('contractTitle', this.cache.contractSummary);
    } else {
      this.projectService.getContractSummary().subscribe(res => {
        this.cache.contractSummary = plainToClass(ContractSummary, res.list);
        this.contractTree = <TreeNode<ContractSummary>[]>this.transformService.convertToTree('contractTitle', this.cache.contractSummary);
        if (this.selectedContractId) {
          this.setSelectedContract(this.selectedContractId);
        }
      });
    }
  }

  ngOnChanges() {
    if (this.selectedContractId && this.contractTree) {
      this.setSelectedContract(this.selectedContractId);
    }
  }

  setSelectedContract(contractId: number): void {
    if (this.contractTree) {
      const index = this.contractTree.findIndex(node => node.data.id == contractId);
      if (index >= 0) {
        this.selectedContract = this.contractTree[index].data;
      }
    } else {
      console.error(`contractTree is null. cannot set selectedContract using input contractId ${contractId}`);
    }
  }

  onNodeSelect(contractNode: TreeNode<ContractSummary>): void {
    this.handler.emit(contractNode);
  }

}
